<template>
  <FloatingCard>
    <!-- Header -->
    <BotMessageHeader :title="botMessageTitle" />
    <p v-if="authMethod === AuthMethods.FranceMock" class="sub-title">
      {{ $t('chat_suggestions.france_sub_title') }}
    </p>
    <div
      class="suggestions"
      v-for="(category, index) in suggestionCategories"
      :key="index"
    >
      <p v-if="category.category" class="text-align-left font-bold padding-b-1">
        {{ category.category }}
      </p>
      <TaskCard
        v-for="(suggestion, index) in category.questions"
        :key="index"
        icon="light-bulb"
        icon-size="body-xl"
        :description="suggestion"
        @click="handleSuggestionClick(suggestion)"
        :fixed-icon-size="false"
      />
    </div>
  </FloatingCard>
</template>
<script setup lang="ts">
import BotMessageHeader from '@/components/common/bot-message-header/BotMessageHeader.vue';
import FloatingCard from '@/components/common/floating-card/FloatingCard.vue';
import TaskCard from '@/components/common/task-card/TaskCard.vue';
import { AuthMethods } from '@/models/auth-methods';
import { SuggestionsCategory } from '@/models/chat.models';
import { useAuthStore } from '@/stores/authStore';

interface Props {
  botMessageTitle: string;
  suggestionCategories: SuggestionsCategory[];
  handleSuggestionClick: (suggestion: string) => void;
}

defineProps<Props>();

const { authMethod } = useAuthStore();
</script>
<style scoped lang="scss">
.sub-title {
  font-size: $body-s-font-size;
  margin-bottom: $space-2;
  color: $color-text-lighter;
}

.suggestions {
  padding-bottom: $space-2;
}

// Styles for big screens
@media (min-height: $small-screen-height) {
  .suggestions {
    padding: $space-3 0;
    padding-bottom: $space-2;
  }

  .sub-title {
    font-size: $body-m-font-size;
  }
}
</style>
